var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirm"},[_c('div',{staticClass:"confirm__header"},[_vm._v("Your password has been changed")]),_c('b-button',{staticClass:"w-100",attrs:{"variant":"primary"},on:{"click":_vm.hideModal}},[_vm._v(" OK ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }